<template>
    <div class="tw:space-y-4">
        <div class="tw:mb-4">
            <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">
                Datos del menor
            </h2>
        </div>

        <div class="tw:grid tw:grid-cols-1 tw:md:grid-cols-3 tw:gap-4">
            <BaseInputText
                label="Nombre"
                name="nombre"
                rules="required"
                :value="value.nombre"
                @input="emitChange('nombre', $event)"
            />
            <BaseInputText
                label="Apellidos"
                name="apellidos"
                rules="required"
                :value="value.apellidos"
                @input="emitChange('apellidos', $event)"
            />
            <BaseInputText
                label="DNI"
                name="dni"
                rules="required"
                :value="value.dni"
                @input="emitChange('dni', $event)"
            />

            <BaseInputText
                label="Fecha de nacimiento"
                name="fecha_nacimiento"
                rules="required"
                :value="value.fecha_de_nacimiento"
                @input="emitChange('fecha_de_nacimiento', $event)"
            />
            <BaseInputText
                label="Fecha de caducidad del DNI"
                name="fecha_caducidad_dni"
                rules="required"
                :value="value.fecha_de_caducidad_dni"
                @input="emitChange('fecha_de_caducidad_dni', $event)"
            />
            <BaseInputText
                label="Teléfono"
                name="telefono"
                rules="required"
                :value="value.telefono"
                @input="emitChange('telefono', $event)"
            />

            <BaseInputText
                label="Email"
                name="email"
                rules="required"
                :value="value.email"
                @input="emitChange('email', $event)"
            />
            <BaseInputText
                label="País de nacimiento"
                name="pais_nacimiento"
                rules="required"
                :value="value.pais_de_nacimiento"
                @input="emitChange('pais_de_nacimiento', $event)"
            />
            <BaseInputText
                label="Provincia de nacimiento"
                name="provincia_nacimiento"
                rules="required"
                :value="value.provincia_de_nacimiento"
                @input="emitChange('provincia_de_nacimiento', $event)"
            />

            <BaseInputText
                label="Localidad de nacimiento"
                name="localidad_nacimiento"
                rules="required"
                :value="value.localidad_de_nacimiento"
                @input="emitChange('localidad_de_nacimiento', $event)"
            />
            <BaseInputText
                label="Nacionalidad"
                name="nacionalidad"
                rules="required"
                :value="value.nacionalidad"
                @input="emitChange('nacionalidad', $event)"
            />
            <BaseInputText
                label="Dirección"
                name="direccion"
                rules="required"
                :value="value.direccion"
                @input="emitChange('direccion', $event)"
            />

            <BaseMultiselect
                label="Lateralidad"
                name="lateralidad"
                rules="required"
                :value="value.lateralidad"
                :options="lateralidadOptions"
                value-key="id"
                label-key="name"
                @input="emitChange('lateralidad', $event)"
            />
            <BaseMultiselect
                label="Equipo"
                name="equipo"
                rules="required"
                :value="value.equipo"
                :options="equipos"
                value-key="id"
                label-key="nombre"
                @input="emitChange('equipo', $event)"
            />
            <BaseInputText
                label="Club de procedencia"
                name="club_procedencia"
                :value="value.club_de_procedencia"
                @input="emitChange('club_de_procedencia', $event)"
            />

            <div class="tw:md:col-span-3">
                <BaseTextarea
                    label="Observaciones"
                    name="observaciones"
                    rows="3"
                    :value="value.observaciones"
                    @input="emitChange('observaciones', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script setup>
    import BaseInputText from '@/modules/admin/ui/BaseInputText.vue';
    import BaseTextarea from '@/modules/admin/ui/BaseTextarea.vue';
    import BaseMultiselect from '@/modules/admin/ui/BaseMultiselect.vue';

    const props = defineProps({
        value: { type: Object, required: true },
        equipos: { type: Array, default: () => [] },
        lateralidadOptions: { type: Array, default: () => [] },
    });

    const emit = defineEmits(['change']);

    function emitChange(field, value) {
        emit('change', { field, value });
    }
</script>
